import { render, staticRenderFns } from "./ebook.vue?vue&type=template&id=4a70c89f&"
import script from "./ebook.vue?vue&type=script&lang=js&"
export * from "./ebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports